const randomizeProviderImages = () => {
    const randomizers = document.querySelectorAll(
        '.wp-block-think-random-provider-pic .provider-randomizer'
    );

    randomizers.forEach((container) => {
        const data = container.dataset.randomize;

        if (!data) return;

        try {
            const images = JSON.parse(data);

            if (!images.length) return;

            const randomImage =
                images[Math.floor(Math.random() * images.length)];

            let img = container.querySelector('img');

            if (!img) {
                img = document.createElement('img');
                img.classList.add('provider-random-image');
                container.appendChild(img);
            }

            img.src = randomImage.mediaURL;
            img.alt = randomImage.mediaALT || '';
        } catch (error) {
            console.error('Invalid randomize data:', error);
        }
    });
};

const updateProviderImageHeights = () => {
    const blocks = document.querySelectorAll(
        '.wp-block-think-nav-card .wp-block-think-random-provider-pic'
    );

    blocks.forEach((block) => {
        const parent = block.closest('.wp-block-think-nav-card');
        const img = block.querySelector('.provider-random-image');

        if (!parent || !img) return;

        // Only apply desktop behavior
        if (window.innerWidth < 782) {
            img.style.height = '';
            img.style.maxWidth = '';
            img.style.left = '';
            img.style.transform = '';
            return;
        }

        // Reset before recalculating
        img.style.height = '';
        img.style.maxWidth = '';

        const parentRect = parent.getBoundingClientRect();
        const blockRect = block.getBoundingClientRect();

        const offsetTop = blockRect.top - parentRect.top;

        const calculatedHeight =
            parent.clientHeight - offsetTop;

        if (calculatedHeight > 0) {
            img.style.height = `${Math.floor(calculatedHeight)}px`;

            /*
             * Delay width unlock slightly
             * so browser calculates height naturally first
             */
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    img.style.maxWidth = 'unset';

                    // Center horizontally
                    img.style.position = 'relative';
                    img.style.left = '50%';
                    img.style.transform = 'translateX(-50%)';
                });
            });
        }
    });
};

const initProviderImageResizeObservers = () => {
    const parents = document.querySelectorAll(
        '.wp-block-think-nav-card'
    );

    parents.forEach((parent) => {
        if (parent._providerResizeObserver) return;

        let resizeFrame = null;

        const observer = new ResizeObserver(() => {
            if (resizeFrame) {
                cancelAnimationFrame(resizeFrame);
            }

            resizeFrame = requestAnimationFrame(() => {
                updateProviderImageHeights();
            });
        });

        observer.observe(parent);

        parent._providerResizeObserver = observer;
    });
};

document.addEventListener('DOMContentLoaded', () => {
    randomizeProviderImages();

    requestAnimationFrame(() => {
        updateProviderImageHeights();
    });

    initProviderImageResizeObservers();

    window.addEventListener(
        'resize',
        updateProviderImageHeights
    );
});